import axios from 'axios'
import { API_ROOT } from '../constants'

// Non-production environments are gated: nginx rejects API requests without this key.
// Set it via devtools: localStorage.setItem('env-access-key', '<secret>')
export const ENV_ACCESS_KEY_STORAGE_KEY = 'env-access-key'
export const ENV_ACCESS_KEY_HEADER = 'X-Tiiny-Env-Key'

const isProduction = () => window.location.origin === 'https://tiiny.host'
const isLocalhost = () => ['localhost', '127.0.0.1'].includes(window.location.hostname)

const getEnvAccessKey = () => {
  try {
    return window.localStorage.getItem(ENV_ACCESS_KEY_STORAGE_KEY)
  } catch (error) {
    return null
  }
}

export const addEnvAccessKeyInterceptor = (instance) => {
  if (isProduction()) return

  instance.interceptors.request.use((config) => {
    const key = getEnvAccessKey()
    if (key && config.url?.startsWith(API_ROOT)) {
      config.headers = { ...config.headers, [ENV_ACCESS_KEY_HEADER]: key }
    }
    return config
  })
}

// Asks nginx whether the stored key is valid.
const verifyEnvAccessKey = async (key) => {
  try {
    const res = await fetch(`${API_ROOT}/env-check`, { headers: { [ENV_ACCESS_KEY_HEADER]: key } })
    return res.ok
  } catch (error) {
    return false
  }
}

// Resolves false when the app should not render (deployed non-production without a valid key).
export const setupEnvAccessKey = async () => {
  if (isProduction()) return true

  addEnvAccessKeyInterceptor(axios)
  if (isLocalhost()) return true

  const key = getEnvAccessKey()
  return Boolean(key) && verifyEnvAccessKey(key)
}
